class TobCaseProjectProcess {
  constructor(container) {
    this.container = container;

    if (this.container.dataset.initialized === 'true') return;
    this.container.dataset.initialized = 'true';

    this.nodes = Array.from(this.container.querySelectorAll('.js-process-node'));
    this.panels = Array.from(this.container.querySelectorAll('.js-process-panel'));
    this.prevButton = this.container.querySelector('.js-process-prev');
    this.nextButton = this.container.querySelector('.js-process-next');
    this.timeline = this.container.querySelector('.js-process-timeline');
    this.currentIndex = 0;

    if (!this.nodes.length || !this.panels.length || !this.timeline) return;

    this.setTimelineColumns();
    this.bindEvents();
    this.activate(0);
  }

  setTimelineColumns() {
    if (window.innerWidth <= 989) {
      this.timeline.style.gridTemplateColumns = '1fr';
    } else {
      this.timeline.style.gridTemplateColumns = `repeat(${this.nodes.length}, minmax(0, 1fr))`;
    }
  }

  bindEvents() {
    this.nodes.forEach((node) => {
      node.addEventListener('mouseenter', () => {
        if (window.innerWidth > 989) {
          this.activate(Number(node.dataset.index));
        }
      });

      node.addEventListener('click', () => {
        this.activate(Number(node.dataset.index));
      });

      node.addEventListener('focus', () => {
        this.activate(Number(node.dataset.index));
      });

      node.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.activate(Number(node.dataset.index));
        }
      });
    });

    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.prev());
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.next());
    }

    window.addEventListener('resize', () => {
      this.setTimelineColumns();
    });
  }

  activate(index) {
    this.currentIndex = index;

    this.nodes.forEach((node) => {
      const isActive = Number(node.dataset.index) === index;
      node.classList.toggle('is-active', isActive);
      node.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = Number(panel.dataset.index) === index;
      panel.classList.toggle('is-active', isActive);
    });
  }

  activateByBlockId(blockId) {
    const node = this.nodes.find((item) => item.dataset.blockId === blockId);
    if (!node) return;
    this.activate(Number(node.dataset.index));
  }

  prev() {
    const nextIndex = this.currentIndex - 1 < 0 ? this.nodes.length - 1 : this.currentIndex - 1;
    this.activate(nextIndex);
  }

  next() {
    const nextIndex = this.currentIndex + 1 >= this.nodes.length ? 0 : this.currentIndex + 1;
    this.activate(nextIndex);
  }
}

const tobCaseProjectProcessInstances = new WeakMap();

function initTobCaseProjectProcess(scope = document) {
  const items = scope.querySelectorAll('.js-tob-process');
  items.forEach((item) => {
    if (!tobCaseProjectProcessInstances.has(item)) {
      tobCaseProjectProcessInstances.set(item, new TobCaseProjectProcess(item));
    }
  });
}

function getProcessInstanceFromTarget(target) {
  const root = target.closest('.js-tob-process');
  if (!root) return null;
  return tobCaseProjectProcessInstances.get(root) || null;
}

document.addEventListener('DOMContentLoaded', () => {
  initTobCaseProjectProcess(document);
});

document.addEventListener('shopify:section:load', (event) => {
  initTobCaseProjectProcess(event.target);
});

document.addEventListener('shopify:block:select', (event) => {
  initTobCaseProjectProcess(document);

  const trigger = event.target.closest('.js-process-node');
  if (trigger) {
    const instance = getProcessInstanceFromTarget(trigger);
    if (instance) {
      instance.activate(Number(trigger.dataset.index));
    }
  }
});

(function () {
  const sectionSelector = '.tob-case-project-process';
  const placeholderSrc = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

  function createLightbox(section) {
    let lightbox = section.querySelector('.tob-case-project-process__lightbox');
    if (lightbox) return lightbox;

    lightbox = document.createElement('div');
    lightbox.className = 'tob-case-project-process__lightbox';
    lightbox.hidden = true;
    lightbox.innerHTML = `<img class="tob-case-project-process__lightbox-image" src="${placeholderSrc}" alt="" hidden>`;

    section.appendChild(lightbox);

    const lightboxImage = lightbox.querySelector('.tob-case-project-process__lightbox-image');

    function closeLightbox() {
      lightbox.hidden = true;
      lightboxImage.hidden = true;
      lightboxImage.src = placeholderSrc;
      lightboxImage.alt = '';
      document.documentElement.classList.remove('tob-case-project-process-lightbox-open');
    }

    lightbox.addEventListener('click', function (event) {
      if (event.target !== lightboxImage) {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !lightbox.hidden) {
        closeLightbox();
      }
    });

    lightbox.openImage = function (img) {
      const src = img.currentSrc || img.src;
      if (!src) return;

      lightboxImage.hidden = false;
      lightboxImage.src = src;
      lightboxImage.alt = img.getAttribute('alt') || '';
      lightbox.hidden = false;
      document.documentElement.classList.add('tob-case-project-process-lightbox-open');
    };

    return lightbox;
  }

  function initProcessLightbox(scope = document) {
    scope.querySelectorAll(sectionSelector).forEach(function (section) {
      const lightbox = createLightbox(section);

      section.querySelectorAll('.tob-case-project-process__image').forEach(function (img) {
        if (img.dataset.lightboxBound === 'true') return;
        img.dataset.lightboxBound = 'true';

        img.addEventListener('click', function () {
          lightbox.openImage(img);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initProcessLightbox(document);
    });
  } else {
    initProcessLightbox(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initProcessLightbox(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    initProcessLightbox(event.target.closest('.shopify-section') || document);
  });
})();